import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

const ModalStatistics = ({ showStatisticModal, setShowStatisticModal }) => {
    const handleClose = () => setShowStatisticModal(false);

    return (
        <Modal show={showStatisticModal} onHide={handleClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Статистика форпостів</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="modal-body modal-body-noborders">
                    <table className="table table-striped ">
                        <tbody>
                            <tr>
                                <td>Головко Ігор Миколайович (+380950015725)</td>
                                <td className="res_name">602299 грн.</td>
                            </tr>
                            <tr>
                                <td>Середа Вадим Олексійович (+380502462048)</td>
                                <td className="res_name">427840 грн.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ModalStatistics;
